import { Input } from 'antd';
import React, { ChangeEvent } from 'react';

import { ICommonInputProps } from './types';

const { TextArea } = Input;
const TextAreaInput: React.FC<ICommonInputProps> = ({
  name,
  inputSettings = { rows: 3 },
  inputClassName,
  value,
  defaultValue,
  onChange,
  disabled,
  onBlur,
}) => {
  const onInputChange = (v: ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(v?.target?.value);
  };
  return (
    <TextArea
      className={`text-area-input ${inputClassName} resize-none`}
      value={value}
      name={name}
      defaultValue={defaultValue}
      rows={inputSettings.rows}
      onChange={onInputChange}
      disabled={disabled}
      onBlur={onBlur}
    />
  );
};

export default React.memo(TextAreaInput);
